import React from 'react';
import {
  CheckSquare,
  FileText,
  Calendar,
  Users,
  Brain,
  Zap,
  BookOpen,
  ShoppingCart,
  Home,
  Target,
  Lightbulb,
  MessageSquare,
  Archive,
  Star,
  Flag,
  AlertCircle,
  BarChart3,
  Clock,
  DollarSign,
  Heart,
  Music,
  Video,
  Code,
  Briefcase,
  Award,
  X,
} from 'lucide-react';

const AVAILABLE_ICONS = [
  { id: 'CheckSquare', name: 'Tareas', icon: CheckSquare },
  { id: 'FileText', name: 'Notas', icon: FileText },
  { id: 'Calendar', name: 'Fechas', icon: Calendar },
  { id: 'Users', name: 'Equipo', icon: Users },
  { id: 'Brain', name: 'Ideas', icon: Brain },
  { id: 'Zap', name: 'Urgente', icon: Zap },
  { id: 'BookOpen', name: 'Aprender', icon: BookOpen },
  { id: 'ShoppingCart', name: 'Compras', icon: ShoppingCart },
  { id: 'Home', name: 'Personal', icon: Home },
  { id: 'Target', name: 'Objetivos', icon: Target },
  { id: 'Lightbulb', name: 'Inspiración', icon: Lightbulb },
  { id: 'MessageSquare', name: 'Comunicación', icon: MessageSquare },
  { id: 'Archive', name: 'Archivo', icon: Archive },
  { id: 'Star', name: 'Favorito', icon: Star },
  { id: 'Flag', name: 'Bandera', icon: Flag },
  { id: 'AlertCircle', name: 'Alerta', icon: AlertCircle },
  { id: 'BarChart3', name: 'Análisis', icon: BarChart3 },
  { id: 'Clock', name: 'Tiempo', icon: Clock },
  { id: 'DollarSign', name: 'Finanzas', icon: DollarSign },
  { id: 'Heart', name: 'Favorito', icon: Heart },
  { id: 'Music', name: 'Música', icon: Music },
  { id: 'Video', name: 'Video', icon: Video },
  { id: 'Code', name: 'Código', icon: Code },
  { id: 'Briefcase', name: 'Trabajo', icon: Briefcase },
  { id: 'Award', name: 'Logro', icon: Award },
];

const IconSelector = ({ currentIcon, onSelectIcon, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 max-h-96 overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Seleccionar icono</h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="grid grid-cols-4 gap-2">
          {AVAILABLE_ICONS.map(({ id, name, icon: Icon }) => (
            <button
              key={id}
              onClick={() => {
                onSelectIcon(id);
                onClose();
              }}
              className={`p-3 rounded-lg border-2 transition flex items-center justify-center ${
                currentIcon === id
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-blue-300'
              }`}
              title={name}
            >
              <Icon className="w-6 h-6 text-gray-700" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export { AVAILABLE_ICONS };
export default IconSelector;
